document.addEventListener('DOMContentLoaded', () => {
	const faq_cards = document.querySelectorAll('.faq-card')
	faq_cards.forEach(card => {
		const paragraph = card.querySelector('p:not(.lg)')
		paragraph.style.setProperty('--text-height', `${paragraph.scrollHeight}px`)
		setTabIndexForLinksInCard(card, '-1')
		card.addEventListener('click', e => {
			toggleCard(card)
		})
		card.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				toggleCard(card)
			}
		})
	})

	window.addEventListener('resize', () => {
		faq_cards.forEach(card => {
			let paragraph = card.querySelector('p:not(.lg)')
			paragraph.style.setProperty('--text-height', 'auto')
			paragraph.style.setProperty(
				'--text-height',
				`${paragraph.scrollHeight}px`
			)
		})
	})
	function toggleCard(card) {
		faq_cards.forEach(item => {
			if (item === card) { 
				if (!item.classList.contains('open')) {
					item.classList.add('open')
					item.setAttribute('aria-expanded', 'true')
					setTabIndexForLinksInCard(item, '0')
				} else {
					item.classList.remove('open')
					item.setAttribute('aria-expanded', 'false')
					setTabIndexForLinksInCard(item, '-1')
				}
			} else {
				item.classList.remove('open')
				item.setAttribute('aria-expanded', 'false')
				setTabIndexForLinksInCard(item, '-1')
			}
		})
	}
	function setTabIndexForLinksInCard(card, tabIndex) {
		const links = card.querySelectorAll('a')
		links.forEach(link => {
			link.setAttribute('tabIndex', tabIndex)
		})
	}
})
